import React, { useState } from 'react';
import { Modal, Spin } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import TemplateHistoryModal from '../TemplateHistoryModal';
import useGetTemplateDetail from 'hooks/videoSetting/useGetTemplateDetail';
import s from './s.module.less';

interface ViewTemplateModalProps {
    open: boolean;
    onCancel: () => void;
    templateId: number;
    specialtyName: string;
    onReopen: () => void;
}

const ViewTemplateModal = ({ open, onCancel, templateId, specialtyName, onReopen }: ViewTemplateModalProps) => {
    const [templateData, templateLoading, fetchTemplate] = useGetTemplateDetail(templateId, Boolean(open));
    const [historyOpen, setHistoryOpen] = useState(false);

    return (
        <>
            <Modal
                open={open}
                onCancel={onCancel}
                footer={null}
                width={800}
                className={s.modal}
                title="View template"
                destroyOnClose
            >
                <Spin spinning={templateLoading}>
                    <div className={s.body}>
                        {!templateData?.isSystem && (
                            <div className={s.topActions}>
                                <button type="button" className={s.historyLink} onClick={() => {
                                    setHistoryOpen(true);
                                    onCancel();
                                }}>
                                    <HistoryOutlined className={s.historyIcon} />
                                    <span>History</span>
                                </button>
                            </div>
                        )}
                        <div className={s.fields}>
                            <div className={s.field}>
                                <div className={s.fieldLabel}>Specialty</div>
                                <div className={s.fieldValue}>{specialtyName}</div>
                            </div>
                            <div className={s.field}>
                                <div className={s.fieldLabel}>Name</div>
                                <div className={s.fieldValue}>{templateData?.name}</div>
                            </div>
                            <div className={s.field}>
                                <div className={s.fieldLabel}>Content</div>
                                <div
                                    className={s.fieldContent}
                                    dangerouslySetInnerHTML={{ __html: templateData?.content || '' }}
                                />
                            </div>
                        </div>
                    </div>
                </Spin>
            </Modal>
            <TemplateHistoryModal
                open={historyOpen}
                onCancel={() => setHistoryOpen(false)}
                templateId={templateId}
                onRestoreSuccess={() => fetchTemplate(templateId)}
                onBack={() => {
                    setHistoryOpen(false);
                    onReopen();
                }}
            />
        </>
    );
};

export default ViewTemplateModal;
